import type ContentfulClient from '@b2ag/contentful'
import type { HomeAdvertorial } from '../../domain/blocs/HomeAdvertorial'
import type { IAdvertorialRepository } from '../../domain/repository/IAdvertorialRepository'

import { mapAdvertorialsFromApi } from '../mapper/homeAdvertorials.mapper'
import { i18n } from '@b2ag/locale'
import { filterBlocsBySegment } from '../../domain/utils/filterContentListBySegment'

export class AdvertorialRepository implements IAdvertorialRepository {
  constructor(public readonly client: ContentfulClient) {}

  async getSupplierAdvertorial(): Promise<HomeAdvertorial[] | null> {
    return this.client.api.withoutUnresolvableLinks
      .getEntries({
        content_type: 'advertorial',
        'fields.supplierName[exists]': true,
        locale: i18n.locale,
      })
      .then((content) => {
        if (content.total === 0) return null
        return mapAdvertorialsFromApi(content.items)
      })
  }

  async getSupplierAdvertorialByTags(tags: string[], keywords: string[] = []): Promise<HomeAdvertorial[] | null> {
    const query = {
      content_type: 'advertorial',
      'fields.supplierName[exists]': true,
      'metadata.tags.sys.id[in]': keywords,
      locale: i18n.locale,
      order: ['-sys.createdAt'],
    }
    if (tags.length) query['metadata.tags.sys.id[in]'] = tags
    if (keywords.length) query['metadata.tags.sys.id[in]'] = keywords
    return this.client.api.withoutUnresolvableLinks.getEntries(query).then((content) => {
      if (content.total === 0) return null
      const segmentedAdvertorials = filterBlocsBySegment(content.items, tags)
      return mapAdvertorialsFromApi(segmentedAdvertorials)
    })
  }
}
